import { useEffect, useRef } from 'react';
import { skipToken } from '@reduxjs/toolkit/query';
import { useAppSelector } from '@/app/hooks';
import { generateBase64FilterQuery } from '@/features/filterHelpers';
import { useSpanCountForFilterQuery } from '@/features/statisticsSlice';
import { useAnalytics } from '@/shell/Analytics';

export const useTrackFilterResults = () => {
  const { track } = useAnalytics();
  const filterState = useAppSelector((state) => state.filterQuery);
  const projectId = useAppSelector(
    (state) => state.analysisMap.currentViewMode.modeDetails?.id
  );
  const filter = filterState.isSelected
    ? generateBase64FilterQuery(filterState)
    : null;
  const { currentData } = useSpanCountForFilterQuery(
    filter ? { filter, listId: projectId ?? undefined } : skipToken
  );
  const lastTrackedFilter = useRef<string | null>(null);

  useEffect(() => {
    if (!filter || !currentData || lastTrackedFilter.current === filter) {
      return;
    }
    lastTrackedFilter.current = filter;
    track('filter_results', {
      span_count: currentData.filtered,
      total_span_count: currentData.total,
    });
  }, [filter, currentData, track]);
};
